/**
 *   Created by Arif Topcu in 2018
 */
import React from 'react';
import Combobox from '@ls/react-combobox-grid';
import SelectionState from 'state/selections/SelectionState';
import { useSelector} from 'react-redux';
import {selectSelectedAccountEntityId} from 'state/selections/selectors';
import {selectFetchingEntities} from 'state/data/selectors';
import {useEntitySelectorOptions, useOnChangeAccount} from 'state/selections';

const columnDefs = [
  {
    headerName: 'Entity ID',
    field: 'entityId',
    width: 75,
    suppressSizeToFit: true,
  },
  {
    headerName: 'Account',
    field: 'label',
    width: 400,
  },
  {
    headerName: 'Code',
    field: 'code',
    width: 100,
  },
  {
    headerName: 'GPS ID',
    field: 'acId',
    suppressSizeToFit: true,
    width: 75,
  }
];

const AccountSelector = props => {
  const entitySelectorOptions = useEntitySelectorOptions();
  const fetchingEntities = useSelector(selectFetchingEntities);
  const selectedAccountEntityId = useSelector(selectSelectedAccountEntityId(SelectionState.UNCOMMITTED));
  const onChange = useOnChangeAccount();

  return (
    <Combobox
      options={entitySelectorOptions}
      onChange={onChange}
      value={selectedAccountEntityId}
      loading={fetchingEntities}
      placeholder="Accounts, Benchmarks..."
      label="Entity:"
      valueKey="entityId"
      labelKey="label"
      columnDefs={columnDefs}
      enableSpeedDial
      variation={1}
      persistKey="COMBOBOX_ACC"
    />
  );
};

export default AccountSelector;
